import React from 'react';
import PropTypes from 'prop-types';
import { OrderView } from '../../../orders/order';
import { GoogleMapsLink } from '@ami/react/core';

const NoInstallation = ({ show }) => {
  if (!show) return null;
  return (
    <div className="text-center mb-3">
      This order does not have installation configured
    </div>
  );
};

const InstallationOptions = ({ installation, show }) => {
  if (!show) return null;

  return (
    <React.Fragment>
      <div className="card installation-card">
        <div className="card-header installation-header">
          <div>
            Installation will be performed at{' '}
            <GoogleMapsLink location={installation.location} />
          </div>
        </div>
        <div className="installation-items">
          {installation.installationOptions.map((option, i) => (
            <div key={i} className="installation-line-item">
              <div className="row">
                <div
                  className="col-12 col-sm-5"
                  style={{ whiteSpace: 'pre-line' }}
                >
                  <div>{option.name}</div>
                  <div>{option.description}</div>
                </div>
                <div className="col-6 col-sm-2">
                  <div className="label">Part Number</div>
                  <strong>{option.partNumber}</strong>
                </div>
                <div className="col-6 col-sm-2">
                  <div className="label">Quantity</div>
                  <strong>{option.quantity}</strong>
                </div>
                <div className="col-12 col-sm-3">&nbsp;</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default class OrderInstallationComponent extends React.PureComponent {
  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
  };

  render() {
    const { installation } = this.props.order;
    const anyInstallationOptions =
      installation && installation.installationOptions.length > 0;
    return (
      <div className="col">
        <div className="card mb-4 box-shadow order-installation h-100">
          <h6 className="card-title installation-title">Installation</h6>
          <NoInstallation show={!anyInstallationOptions} />
          <InstallationOptions
            installation={installation}
            show={anyInstallationOptions}
          />
        </div>
      </div>
    );
  }
}
